<template>
    <sc-link :field="fields.internalLink">
        <sc-image :media="fields.image" />
        <div class="carousel-text">
            <sc-text tag="h2" class="" :field="fields.headline" />
            <sc-text tag="p" class="" :field="fields.subHeader" />
        </div>
    </sc-link>
</template>

<script>
import { Text, Image as ScImage, Link as ScLink } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'CarouselItem',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    ScText: Text,
    'sc-image': ScImage,
    'sc-link': ScLink,
  },
computed: {
    fields() {
        // rendering.fields are populated from route YAML (disconnected)
        // or from Layout Service (integrated)
        return this.rendering?.fields || {};
    },
    imageUrl() {
        const img = this.fields?.image || {};
        // try common shapes used by disconnected/layout service
        return img.src || (img.value && img.value.src) || (img.fields && img.fields.src) || '';
    },
  },
};
</script>